<script>
    export let level;
    export let cardTitle;
    export let link;
    export let content;
</script>

    
<div class="icard {level} block feed">
    <h3>{cardTitle}</h3>
    {#each content as c}
    <a href="{c.link}/?int_campaign=shape_your_la&int_medium=rss&int_source=rss">
        <div>
            <span class="mini-icon">🏠</span>
            <p>{c.title}</p>
        </div>
    </a>
    {/each}
</div>